import {
    FETCHED_SECTION_SETTINGS,
    FETCHED_IMAGE_SETTINGS,
    FETCHED_SECTIONS_VIDEO_SETTINGS
} from './types';
import update from 'immutability-helper';

const INITIAL_STATE = {
    imageSettings: [],
    videoSettings: [],
    sectionSettings: [],
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        case FETCHED_SECTION_SETTINGS:

            return update(state, {
                sectionSettings: {$set: action.payload.sectionSettings}
            });
        
        case FETCHED_IMAGE_SETTINGS:

            return update(state, {
                imageSettings: {$set: action.payload.imageSettings}
            });

        case FETCHED_SECTIONS_VIDEO_SETTINGS:

            return update(state, {
                videoSettings: {$set: action.payload.videoSettings}
            });

        default:
            return state;
    }

}


// WEBPACK FOOTER //
// ./src/containers/pages/settings/reducer.js